import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import FilterIcon from "../../assets/Icons/Orange Filter.png";
import Dropdown from "../Dropdown";
import {
  emptyOrderScopeFilters,
  fetchOrderFilterOptions,
  cascadeOrderFilterOptions,
  orderScopeOptionLabel,
} from "../../helpers/orderFilterOptions";
import { format, parse } from "date-fns";

const OrderFilterModal = ({
  show,
  handleClose,
  setOrderData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  user,
  orderDataList = [],
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      ...filterData,
      retailerId: filterData.retailerId || "",
      expressType: filterData.expressType || "",
      retailerName: filterData.retailerName || "",
      consigneeName: filterData.consigneeName || "",
      consigneeMobile: filterData.consigneeMobile || "",
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
      ourWaybillNumber: filterData.ourWaybillNumber || "",
      hubCode: filterData.hubCode || "",
      subLmbpCode: filterData.subLmbpCode || "",
      filterUserId: filterData.filterUserId || "",
    },
    mode: "onChange",
  });

  // Watch all form values to check if a filter has a value
  const watchedValues = watch();

  // Function to check if a tab has an active filter value
  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "LMBP Name":
        return filterData?.retailerId && filterData.retailerId.trim() !== "";
      case "Consignee Name":
        return Boolean(
          (filterData?.consigneeName && filterData.consigneeName.trim() !== "") ||
          (watchedValues?.consigneeName && watchedValues.consigneeName.trim() !== "")
        );
      case "Consignee Mobile":
        return (
          filterData?.consigneeMobile &&
          filterData.consigneeMobile.trim() !== ""
        );
      case "Created Date":
        return (
          (filterData?.fromDate && filterData.fromDate !== "") ||
          (filterData?.toDate && filterData.toDate !== "")
        );
      case "Ewaybill Number":
        return (
          filterData?.ourWaybillNumber &&
          filterData.ourWaybillNumber.trim() !== ""
        );
      case "Express Type":
        return filterData?.expressType && filterData.expressType.trim() !== "";
      case "Hub":
        return Boolean(filterData?.hubCode);
      case "Sub-LMBP":
        return Boolean(filterData?.subLmbpCode);
      case "User":
        return Boolean(filterData?.filterUserId);
      default:
        return false;
    }
  };

  const [selectedTab, setSelectedTab] = useState(
    user?.data?.userProfile === "CUSTOMER" ? "Created Date" : "LMBP Name",
  );
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");
  const [lmbpList, setLmbpList] = useState([]);
  const [scopeOptions, setScopeOptions] = useState(null);
  const [fetchedConsignees, setFetchedConsignees] = useState([]);
  const [consigneesRequested, setConsigneesRequested] = useState(false);

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  // Get available tabs based on user profile
  const getAvailableTabs = () => {
    const allTabs = [
      ...(scopeOptions?.hubs?.length ? ["Hub"] : []),
      "LMBP Name",
      ...(scopeOptions?.subLmbps?.length ? ["Sub-LMBP"] : []),
      ...(scopeOptions?.users?.length ? ["User"] : []),
      "Created Date",
      "Consignee Name",
      "Consignee Mobile",
      "Express Type",
      "Ewaybill Number",
    ];

    if (user?.data?.userProfile === "CUSTOMER") {
      // Hide Wallet Number and Created By for CUSTOMER
      // LMBP users only ever see their own orders here
      return allTabs.filter(
        (tab) => !["LMBP Name", "Hub", "Sub-LMBP", "User"].includes(tab),
      );
    }

    return allTabs;
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchOrderData(currentPage, data);
  };

  const fetchOrderData = async (page, formData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        retailerId: formData.retailerId || "",
        expressType: formData.expressType || "",
        // retailerName: formData.retailerName || "",
        consigneeName: formData.consigneeName || "",
        consigneeMobile: formData.consigneeMobile || "",
        fromDate: formatDate(formData.fromDate),
        toDate: formatDate(formData.toDate),
        ourWaybillNumber: formData.ourWaybillNumber || "",
        hubCode: formData.hubCode || "",
        subLmbpCode: formData.subLmbpCode || "",
        filterUserId: formData.filterUserId || "",
        // ...(user?.data?.userProfile === "OPERATION" && formData.ourWaybillNumber
        //   ? { ourWaybillNumber: formData.ourWaybillNumber }
        //   : {}),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_ORDER_MASTER_DATA}?pageSize=${pageSize}&pageNo=${page}`,
        requestBody,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        let modifiedData = modifyStructure(response?.data?.data);
        if (formData.consigneeName && formData.consigneeName.trim() !== "") {
          const query = formData.consigneeName.trim().toLowerCase();
          modifiedData = modifiedData.filter((item) =>
            (item?.consigneeName || "").toLowerCase().includes(query)
          );
        }
        setOrderData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setOrderData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formatAmount = (value) => {
        if (value === undefined || value === null || value === "") return "";
        return Number(value).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      };

      return {
        ...user,

        remark: user?.cancelRemark ?? user?.cancelReason ?? "-",

        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",

        codAmount: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.codAmount)}
          >
            {formatAmount(user.codAmount)}
          </div>
        ),

        orderAmount: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.orderAmount)}
          >
            {formatAmount(user.orderAmount)}
          </div>
        ),

        gst: (
          <div
            style={{
              width: "101px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.gst)}
          >
            {formatAmount(user.gst)}
          </div>
        ),

        gstAmount: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.gstAmount)}
          >
            {formatAmount(user.gstAmount)}
          </div>
        ),

        fuelCharges: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.fuelCharges)}
          >
            {formatAmount(user.fuelCharges)}
          </div>
        ),

        amount: (
          <div
            style={{
              width: "100px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.amount)}
          >
            {formatAmount(user.amount)}
          </div>
        ),

        totalCharges: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.totalCharges)}
          >
            {formatAmount(user.totalCharges)}
          </div>
        ),

        date: format(formattedCreDate, "dd-MM-yyyy"),
      };
    });
    return modified;
  };

  useEffect(() => {
    fetchActiveLmbpData();
    if (user?.data?.userProfile !== "CUSTOMER") {
      fetchOrderFilterOptions().then(setScopeOptions);
    }
  }, []);

  // Hub, Sub-LMBP and User lists follow the hub and LMBP already picked
  const scopeLists = cascadeOrderFilterOptions(
    scopeOptions,
    {
      hubCode: filterData.hubCode,
      // An LMBP Name pick that is a master LMBP narrows to its sub-LMBPs
      lmbpCode: scopeOptions?.lmbps?.some((l) => l.code === filterData.retailerId)
        ? filterData.retailerId
        : "",
      subLmbpCode: filterData.subLmbpCode,
    },
  );
  const withLabels = (list, valueKey) =>
    list.map((item) => ({ ...item, label: orderScopeOptionLabel(item, valueKey) }));

  // Sets a hub / LMBP Name / sub-LMBP / user pick and clears the picks below it
  const setScopeFilter = (changes) => {
    Object.entries(changes).forEach(([k, v]) => setValue(k, v));
    setFilterData((prev) => ({ ...prev, ...changes }));
  };

  // Consignee suggestions are loaded only when the Consignee Name tab is opened,
  // and only for the selected date range. Loading 500 orders from all dates on
  // every popup open was slow enough to fail on prod, which lost the rotated
  // auth token and made the next request fail with 403 "Invalid Token".
  useEffect(() => {
    if (selectedTab === "Consignee Name" && !consigneesRequested) {
      setConsigneesRequested(true);
      fetchConsigneeList();
    }
  }, [selectedTab, consigneesRequested]);

  const fetchConsigneeList = async () => {
    try {
      const requestBody = {
        username: loggedInUserName,
        status: [],
        fromDate: formatDate(watchedValues?.fromDate || filterData?.fromDate),
        toDate: formatDate(watchedValues?.toDate || filterData?.toDate),
      };
      const response = await axiosPostApi(
        `${apiList.FETCH_ORDER_MASTER_DATA}?pageSize=100&pageNo=1`,
        requestBody,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00" &&
        Array.isArray(response?.data?.data)
      ) {
        const names = response.data.data
          .map((item) => (item?.consigneeName || "").trim())
          .filter(Boolean);
        setFetchedConsignees(Array.from(new Set(names)));
      }
    } catch (err) {
      console.error("Error fetching consignee names:", err);
    }
  };

  const fetchActiveLmbpData = async () => {
    setLoading(true);
    try {
      const response = await axiosGetApi(
        `${apiList.ALL_ACTIVE_CUSTOMER_DATA}?username=${loggedInUserName}`,
      );

      if (response?.status === 200) {
        setLmbpList(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching LMBP data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const combinedConsignees = React.useMemo(() => {
    const set = new Set();

    // 1. From prop orderDataList (current table data shown to user)
    if (Array.isArray(orderDataList)) {
      orderDataList.forEach((order) => {
        const name = (order?.consigneeName || "").trim();
        if (name) {
          set.add(name);
        }
      });
    }

    // 2. From fetched orders
    if (Array.isArray(fetchedConsignees)) {
      fetchedConsignees.forEach((name) => {
        const trimmed = (name || "").trim();
        if (trimmed) {
          set.add(trimmed);
        }
      });
    }

    return Array.from(set);
  }, [orderDataList, fetchedConsignees]);

  const sortedConsignees = React.useMemo(() => {
    return [...combinedConsignees].sort((a, b) =>
      a.localeCompare(b, undefined, {
        sensitivity: "base",
      }),
    );
  }, [combinedConsignees]);

  const consigneeOptions = React.useMemo(() => {
    const list = sortedConsignees.map((name) => ({
      label: name,
      value: name,
      consigneeName: name,
    }));

    if (watchedValues?.consigneeName || filterData?.consigneeName) {
      return [
        {
          label: "✕ Clear Consignee Selection",
          value: "",
          consigneeName: "",
        },
        ...list,
      ];
    }
    return list;
  }, [sortedConsignees, watchedValues?.consigneeName, filterData?.consigneeName]);

  const onReset = () => {
    reset({
      retailerId: "",
      retailerName: "",
      consigneeName: "",
      consigneeMobile: "",
      fromDate: "",
      toDate: "",
      ourWaybillNumber: "",
      expressType: "",
      ...emptyOrderScopeFilters,
    });
    setFilterData({
      retailerId: "",
      retailerName: "",
      consigneeName: "",
      consigneeMobile: "",
      fromDate: "",
      toDate: "",
      ourWaybillNumber: "",
      expressType: "",
      ...emptyOrderScopeFilters,
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title">Filter</h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {/* {
                      [
                        "LMBP Name",
                        "Consignee Name",
                        "Consignee Mobile",
                        "Created Date",
                        ...(user?.data?.userProfile === "OPERATION"
                          ? ["Ewaybill Number"]
                          : []),
                      ] */}
                      {getAvailableTabs().map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "LMBP Name" && (
                        <Dropdown
                          label="LMBP Name"
                          value={filterData.retailerId}
                          onChange={(item) => {
                            setScopeFilter({
                              retailerId: item.customerCode,
                              retailerName: item.name,
                              subLmbpCode: "",
                              filterUserId: "",
                            });
                          }}
                          labelKey="name"
                          valueKey="customerCode"
                          options={lmbpList}
                          // error={errors.lmbpUser}
                        />
                      )}

                      {selectedTab === "Hub" && (
                        <Dropdown
                          label="Hub"
                          value={filterData.hubCode}
                          onChange={(item) =>
                            setScopeFilter({
                              hubCode: item.code,
                              subLmbpCode: "",
                              filterUserId: "",
                            })
                          }
                          valueKey="code"
                          options={withLabels(scopeLists.hubs, "code")}
                        />
                      )}

                      {selectedTab === "Sub-LMBP" && (
                        <Dropdown
                          label="Sub-LMBP"
                          value={filterData.subLmbpCode}
                          onChange={(item) =>
                            // A sub-LMBP is an LMBP in its own right: it replaces the LMBP Name pick
                            setScopeFilter({
                              subLmbpCode: item.code,
                              retailerId: "",
                              retailerName: "",
                              filterUserId: "",
                            })
                          }
                          valueKey="code"
                          options={withLabels(scopeLists.subLmbps, "code")}
                        />
                      )}

                      {selectedTab === "User" && (
                        <Dropdown
                          label="User"
                          value={filterData.filterUserId}
                          onChange={(item) =>
                            setScopeFilter({ filterUserId: item.userId })
                          }
                          valueKey="userId"
                          options={withLabels(
                            filterData.retailerId &&
                              !filterData.subLmbpCode &&
                              !scopeOptions?.lmbps?.some(
                                (l) => l.code === filterData.retailerId,
                              )
                              ? scopeLists.users.filter(
                                  (u) => u.code === filterData.retailerId,
                                )
                              : scopeLists.users,
                            "userId",
                          )}
                        />
                      )}

                      {selectedTab === "Consignee Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">
                              Consignee Name
                            </label>
                            <Dropdown
                              placeholder="Select Consignee Name"
                              options={consigneeOptions}
                              value={watchedValues?.consigneeName || filterData?.consigneeName || ""}
                              labelKey="label"
                              valueKey="value"
                              showSearch={true}
                              selectClassName="!h-[38px] !rounded-[6px]"
                              onChange={(item) => {
                                const selectedName = item
                                  ? item.consigneeName || item.value || ""
                                  : "";
                                setValue("consigneeName", selectedName);
                                setFilterData((prev) => ({
                                  ...prev,
                                  consigneeName: selectedName,
                                }));
                              }}
                            />
                            {errors.consigneeName && (
                              <div className="error-text">
                                {errors.consigneeName.message}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Consignee Mobile" && (
                        <Controller
                          name="consigneeMobile"
                          control={control}
                          rules={{
                            minLength: {
                              value: 10,
                              message: "Mobile No must be at least 10 digits",
                            },
                            pattern: {
                              value: /^[6-9]\d{9}$/,
                              message:
                                "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9",
                            },
                            validate: {
                              noRepeats: (value) =>
                                !/^([0-9])\1*$/.test(value) ||
                                "Repeated digits are not allowed",
                            },
                          }}
                          render={({ field }) => (
                            <div className="dateField">
                              <div className="dateInputWrapper">
                                <label className="dateLabel">
                                  Consignee Mobile
                                </label>
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Consignee Mobile"
                                  className="dateInput"
                                  maxLength={10}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(
                                      /[^0-9]/g,
                                      "",
                                    );
                                    field.onChange(val);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      consigneeMobile: val,
                                    }));
                                  }}
                                />
                                {errors.consigneeMobile && (
                                  <div className="error-text">
                                    {errors.consigneeMobile.message}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value) =>
                                  !value ||
                                  !filterData.toDate ||
                                  new Date(value) <=
                                    new Date(filterData.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value) =>
                                  !value ||
                                  !filterData.fromDate ||
                                  new Date(value) >=
                                    new Date(filterData.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Ewaybill Number" &&
                        // user?.data?.userProfile === "OPERATION" && (
                          <Controller
                            name="ourWaybillNumber"
                            control={control}
                            render={({ field }) => (
                              <div className="dateField">
                                <div className="dateInputWrapper">
                                  <label className="dateLabel">
                                    Ewaybill Number
                                  </label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter Ewaybill Number"
                                    className="dateInput"
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        ourWaybillNumber: e.target.value,
                                      }));
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          />
                        // )
                        }

                      {selectedTab === "Express Type" && (
                        <Dropdown
                          label="Express Type"
                          value={filterData.expressType}
                          onChange={(item) => {
                            setValue("expressType", item.value);
                            setFilterData((prev) => ({
                              ...prev,
                              expressType: item.value,
                            }));
                          }}
                          options={[
                            { value: "air", label: "Air" },
                            { value: "surface", label: "Surface" },
                          ]}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back !rounded-lg w-[133px]"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit !rounded-lg w-[133px]"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderFilterModal;
